import RemovePripomienkaButton from './RemovePripomienkaButton';

export default RemovePripomienkaButton;
